<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3> 
            </div>
        </div>
    </div>
    <div v-else>
    <br>
    <b-row>
        <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listDebitNote">
                    <option :value="'asc'">Mas Antiguo</option>
                    <option :value="'desc'">Mas Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
              <b-form inline>
                  Desde: <b-input type="date" v-model="f1"/>
                  Hasta: <b-input type="date" v-model="f2"/>
              </b-form>
         </b-col>
        <b-col>
          <b-button @click="listDebitNote" variant="success">Buscar</b-button>
        </b-col>
        <b-col md="2">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listDebitNote"><i class="fa fa-sync-alt"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listDebitNote">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>                            
                </b-input-group>                        
            </b-form-group>                    
        </b-col>
    </b-row>
    <br>
    <b-table
        responsive 
        :small="small"
        :striped="striped"
        :outlined="outlined"
        :items="debitnotes"
        :fields="debitnotes_fields"
        :current-page="pactual"
        :per-page="limite"                   
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"  
        >
        <template slot="estado" slot-scope="row">
            <template v-if="row.item.emitido==1 && row.item.baja==1">
                <div><span class="badge badge-dark">Baja <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else>
                <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                <div v-else-if="row.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
                <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
            </template>
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.receiver">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ row.item.idReceptor }}
            </template>            
        </template>
        <template slot="emision" slot-scope="row">
            <template v-if="row.item.fechaEmision !== '0000-00-00 00:00:00'">
                {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
            </template>
            <template v-else>
                -
            </template>            
        </template>
        <template slot="moneda" slot-scope="row">
            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ row.item.tipoMoneda }}</template>                     
            {{row.item.importeTotal}}
        </template>
        <template slot="acciones" slot-scope="row">
            <template v-if="row.item.emitido!=2 && row.item.baja!=1">
                <b-button-group>
                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                    <b-button v-b-tooltip.hover v-b-modal.modalprevnc @click="viewPdf(row.item)"><i title="Vista Previa" class="fa fa-tv"></i></b-button>
                    <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i title="Descargar PDF" class="fa fa-file-pdf"></i></b-button>                        
                    <b-button @click="setNote(row.item)" v-b-modal.modalsendnc v-b-tooltip.hover><i title="Enviar por Mail" class="fa fa-envelope"></i></b-button>                      
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-else @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-if="row.item.emitido==0 || row.item.baja==1" v-show="row.item.emitido!=3 || row.item.baja==1" :disabled="true" v-b-tooltip.hover class="disabled btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button>
                    <b-button v-else v-show="row.item.emitido!=3 || row.item.baja==1" @click="preBaja(row.item)" v-b-tooltip.hover class="btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button>                    
                </b-button-group>
            </template>
            <template v-else>
                <b-button-group>
                    <b-button @click="downloadCdr(row.item)" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo3 v-b-tooltip.hover title="Estado de la emision" class="btn" variant = "primary"><i class="fa fa-eye text-white"></i></b-button>
                </b-button-group>
            </template>
        </template>  
        <template slot="row-details" slot-scope="row">
            <b-card class="tamanioletra">
                <b-table striped hover :items="row.item.lista" :fields="listaitems_fields" :busy="row.item.loading">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="index" slot-scope="row">
                        {{ row.index+1 }}
                    </template>
                    <template slot="cantidad" slot-scope="row">
                        <div class="text-right">
                            {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                        </div>
                    </template>
                    <template slot="precioVentaUnitario" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.precioVentaUnitario">
                                {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                            </template>
                        </div>
                    </template>
                    <template slot="descuento" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template v-else>
                                0.00
                            </template>
                        </div>
                    </template>     
                    <template slot="valorVenta" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.valorVenta">
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}
                            </template>
                        </div>
                    </template>
                </b-table>
            </b-card>
        </template>           
    </b-table>
    <b-modal v-model="modalsendnc"  id="modalsendnc" title="Enviar por Correo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(note)" class="input-requierido"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(note)">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando... 
            </b-btn>
        </div>
    </b-modal>  
    <b-modal id="motivorechazo3" title="Motivo del Rechazo" v-model="motivoRechazo">
        <div role="group">
            <div v-if="spinoff">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h6>{{ descripcionRechazo }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                Ok
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="modalprevnc" size="lg" title="Vista Previa" cancel-title="Cerrar">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>                
    </b-modal>
    <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listDebitNote"></b-pagination>
        </div>
    </div>
    <b-modal id="modalpreproccess" v-model="modal">
        <template slot="modal-title">
            <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a una Nota de Debito
        </template>
        <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja a la siguiente Nota de Debito?</p>
        <b-list-group>
            <template>
                <template>
                    <b-list-group-item>{{facturaItemBaja.serie + '-' + facturaItemBaja.numero + ' | ' + facturaItemBaja.idReceptor + '-' + facturaItemBaja.razonSocial}}</b-list-group-item>
                </template>
            </template>
        </b-list-group>
        <br>
        <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
        <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
        <template slot="modal-footer">
            <template v-if="!loading2">
            <b-button variant="secondary" @click="modal=false">No</b-button>
            <b-button variant="danger" @click="sendBaja"><i class="fa fa-cog"></i> Procesar</b-button>
            </template>
            <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"></i> Procesando</b-button>
        </template>  
    </b-modal>
    <vue-snotify></vue-snotify>
</div>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
export default {
    name: 'NotaDebitoFacturaConsulta',
    components: {
        Datepicker
    },
    props: ['reload'],
    data: () => {
        return {
            facturaItemBaja: {
                serie: '',
                numero: '',
                idReceptor: '',
                razonSocial: ''
            },
            facturaBaja: {
                descripcion: 'DE BAJA',
                serie: '',
                numero: '',
                tipoComprobante: '01'
            },
            itembaja: [],
            loading2: false,
            modal: false,
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            reloadLocal: false,
            sortDesc: false,
            sortDirection: 'asc',
            sortBy: null,
            currentPage: 1,
            striped: true,
            small: true,
            outlined: true,
            modalInfo: { holi1: 'holi', holi2: 'holi2' },
            itemAlterado: false,
            montoActual: '',
            montoDescuento: '',
            fieldsNC: ['cantidad', 'descripcion', 'valorUnitario', 'valorVenta', 'actions', 'acciones'],
            invoice: [],
            listaNotaCredito: [],
            listaNotaCreditoAfectada: [],
            descuentoItemSiguiente: false,
            generalesNC: false,
            especificacionIgv1: EspecificacionIgvTipo1,
            especificacionIgv2: EspecificacionIgvTipo2,
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            emisioncreditnote: false,
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',     
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                {
                    id: '03',
                    descripcion: 'Exonerado'
                },
                {
                    id: '04',
                    descripcion: 'Exportación'
                }
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            debitnotes: [],
            debitnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Importe Total', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                {key: 'index'},
                {key: 'codigoProducto', label: 'Codigo', sorteable: true},
                {key: 'unidadMedidaCantidad', label: 'Unidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'precioVentaUnitario', label: 'Precio Unit', sorteable: true},
                {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: 'valorVenta', label: 'Precio Total', sorteable: true},
            ],
            note: {},
            items: [],
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            serieNC: '',
            checkSerieNC: false,
            responseSerieNC: '',
            descripcionNC: '',
            checkDescripcionNC: false,
            responseDescripcionNC: '',
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            checkserie: false,
            checknumero: false,
            diasnopermitidos: {
            ranges: []
            },
            tiponotacredito: '01',
            f1:'',
            f2:'',
        }
    },
    mounted () {
        this.listDebitNote()
    },
    watch: {
        reload: function () {
           this.reloadLocal = this.reload
            if(this.reloadLocal == true){
                this.listDebitNote()
            } 
        }
    },
    methods: {
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.debitnotes[index].mostrardetalles = false
            }else{
                this.debitnotes[index].mostrardetalles = true
                this.debitnotes[index].loading = true
                if(this.debitnotes[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.debitnotes[index].loading = false
                    row.toggleDetails()
                }  
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/items',{
                token: this.$store.getters.userToken,
                iddebit: row.item.idNotaDebito
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index)
            ))
            .catch(error => (  
                this.debitnotes[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            this.debitnotes[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.debitnotes[index].lista.push(value[i])
            }
            this.debitnotes[index].loading = false
            // this.debitnotes[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        preBaja: function (value) {
            this.modal = true,
            this.itembaja = [],
            this.facturaItemBaja.serie = value.serie,
            this.facturaItemBaja.numero = value.numero,
            this.facturaItemBaja.idReceptor = value.idReceptor,
            this.facturaItemBaja.razonSocial = value.receiver.razonSocial,
            this.facturaBaja.descripcion = 'DE BAJA',
            this.facturaBaja.serie = value.serie,
            this.facturaBaja.numero = value.numero,
            this.facturaBaja.tipoComprobante = '08',
            this.itembaja.push(this.facturaBaja),
            this.date = value.fechaEmision
        },
        sendBaja: function () {
            this.loading2 = true
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja/emitir', {
                token: this.$store.getters.userToken,
                fechaEmisionDocs: this.$moment(this.date).format('YYYY-MM-DD'),
                items: this.itembaja
            })
            .then(response => ( 
                this.loading2 = false,               
                this.modal = false,
                this.listDebitNote(),
                this.initValuesBaja(),
                this.$snotify.success(response.data.msg, 'Éxito')
            ))
            .catch(error => (
                this.loading2 = false,
                this.modal = false,
                this.initValuesBaja()
                // this.$snotify.error(error.response.data.response.description, 'Error')
            )) 
        },
        initValuesBaja: function() {
            this.facturaItemBaja.serie = '',
            this.facturaItemBaja.numero = '',
            this.facturaItemBaja.idReceptor = '',
            this.facturaItemBaja.razonSocial = '',
            this.facturaBaja.descripcion = 'DE BAJA',
            this.facturaBaja.serie = '',
            this.facturaBaja.numero = '',
            this.facturaBaja.tipoComprobante = '01',
            this.itembaja = []
        },
        listDebitNote: function () {
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/factura', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.debitnotes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                this.debitnotes.forEach(function(element){
                    element.loading = false
                })
                ))
            .catch(error => {})
        },
        setNote: function (data) {
            this.note = data
        },
        sendMail: function (data) {
            this.modalsendnc = true
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaDebito,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.success(response.data.msg, 'Exito')            
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.error(error.response.data.message + ' Verifique! Si el documento esta en proceso no podra enviarlo por correo', 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))         
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/constancia',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            // tag.classList.add('fa','fa-spin', 'fa-spinner', '')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/xml', {
                token: this.$store.getters.userToken,
                id: data.idNotaDebito
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
            }  
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '01'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
    .espacio {
        margin-left: 15px;
    }
    .messageTipoNotaCredito {
        color: #8d8d8d;
        font-size: 11px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
</style>



